import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import { BaseQuestionComponent } from '../base-question.component';

/**
 * TODO's:
 * - Matomo Track will only trigger when we check the form -> moved to state
 */
@Component({
    selector: 'medsurf-quiz-indication-question',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './indication-question.component.html',
    styleUrls: ['./indication-question.component.scss'],
    standalone: false
})
export class IndicationQuestionComponent extends BaseQuestionComponent<FlatModels.QuestionEntityModels.IndicationQuestion, FlatModels.TrainingSharedModels.IndicationQuestionResult> {
  /**
   * Is Correct
   */
  public isCorrect(): boolean {
    if (this.trainingResult.answer === null) {
      return false;
    }
    return this.question.solution.toString() === this.trainingResult.answer.toString();
  }

  /**
   * Pass Required
   */
  public passRequired(): boolean {
    if (this.question.required) {
      return Number.isInteger(this.trainingResult.answer);
    }
    return true;
  }

  /**
   * On Click
   *
   * @param value
   */
  public onClick(value: number) {
    this.trainingResult.answer = value;
    this.trainingSharedFacade.requestUpdateSlideResult(this.trainingResult);
  }
}
